'use client';

import { Badge } from '@/shared/ui/badge';
import type { MiniBannerCounterBadgeProps } from './types';

export const MiniBannerBadge = ({
  isPhMobile,
  text,
}: MiniBannerCounterBadgeProps) => (
  <Badge
    color="#FF6601"
    text={text}
    {...(isPhMobile
      ? {
          mobileSize: '16px',
          offsetTop: '-7px',
          offsetRight: '-6px',
          fontWeight: 500,
          lineHeight: '1.4',
          fontSize: 10,
        }
      : {})}
  />
);
